<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import { RouterLink } from 'vue-router';
import { FhCard, FhIcon, FhText } from '@fareharbor-com/beacon-vue';

interface QuickLinkCardProps {
  icon: object;
  title: string;
  description: string;
  to?: RouteLocationRaw;
  href?: string;
}

defineProps<QuickLinkCardProps>();
</script>

<template>
  <FhCard :is-interactive="true">
    <router-link v-if="to" :to="to" class="block p-4">
      <div class="flex items-center">
        <FhIcon
          :icon="icon"
          class="mr-3 flex-shrink-0"
          :style="{ color: 'var(--fh-color-text-primary-default)' }"
          size="md"
        />
        <div class="flex-grow">
          <FhText
            variant="body-md"
            :color="'primary-default'"
            class="font-medium hover:underline"
          >
            {{ title }}
          </FhText>
          <FhText variant="body-sm" :color="'default'" class="mt-1">
            {{ description }}
          </FhText>
        </div>
      </div>
    </router-link>
    <a
      v-else-if="href"
      :href="href"
      target="_blank"
      rel="noopener noreferrer"
      class="block p-4"
    >
      <div class="flex items-center">
        <FhIcon
          :icon="icon"
          class="mr-3 flex-shrink-0"
          :style="{ color: 'var(--fh-color-text-primary-default)' }"
          size="md"
        />
        <div class="flex-grow">
          <FhText
            variant="body-md"
            :color="'primary-default'"
            class="font-medium hover:underline"
          >
            {{ title }}
          </FhText>
          <FhText variant="body-sm" :color="'default'" class="mt-1">
            {{ description }}
          </FhText>
        </div>
      </div>
    </a>
    <div v-else class="p-4 text-red-500">
      Error: QuickLinkCard requires either a 'to' or 'href' prop.
    </div>
  </FhCard>
</template>
